<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="教育局名称">
          <a-input
            class="form-cell"
            type="text"
            v-model="queryParam.bureauName"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="地区"
          class="form-oper"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-cascader
            v-if="$store.state.common.address.length > 0"
            class="form-cell"
            :options="$store.state.common.address"
            placeholder="请选择"
            changeOnSelect
            v-model="queryParam.addressSelect"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          />
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchBureau()">查询</a-button>
          <a-button type="primary" @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="list-oper">
      <a-button type="primary" icon="plus" @click="$refs.bureauForm.init('add')"
        >新建</a-button
      >
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="bureauList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
      :rowKey="getRowKey"
    >
      <span slot="id"></span>
      <span slot="bureauName"></span>
      <span slot="address" slot-scope="text, record">
        <template>
          <span
            >{{ record.provinceId | codeFilter }}{{ record.cityId | codeFilter
            }}{{ record.districtId | codeFilter }}</span
          >
        </template>
      </span>
      <span slot="gmtCreate"></span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="$refs.customSetting.init(record)">个性化</a>
          <a-divider type="vertical" />
          <a @click="$refs.bureauForm.init('update', record)">修改</a>
          <a-divider type="vertical" />
          <a @click="deleteBureau(record)">删除</a>
        </template>
      </span>
    </a-table>
    <bureau-form-modal
      ref="bureauForm"
      @addBureau="addBureau"
      @updateBureau="updateBureau"
    ></bureau-form-modal>

    <custom-setting
      ref="customSetting"
      @updateBureau="updateBureau"
    ></custom-setting>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import bureau from '../../api/bureau'

import BureauFormModal from './BureauFormModal'

import { getDate } from '../../utils/date'

import { analysisAddress } from '../../utils/address'

import CustomSetting from './components/CustomSetting'

const columns = [
  {
    title: '教育局名称',
    dataIndex: 'bureauName',
    key: 'bureauName',
  },
  {
    title: '负责人名称',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '代理',
    dataIndex: 'agentName',
    key: 'agentName',
  },
  {
    title: '域名',
    dataIndex: 'domainName',
    key: 'domainName',
  },
  {
    title: '站点名称',
    dataIndex: 'siteName',
    key: 'siteName',
  },
  {
    title: '地区',
    dataIndex: 'address',
    key: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'bureauList',
  data() {
    return {
      bureauList: [], //教育数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
    }
  },
  components: {
    CTable,
    BureauFormModal,
    CustomSetting,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    //修改一个教育局
    updateBureau(bureau) {
      for (let i in this.bureauList) {
        if (this.bureauList[i].id == bureau.id) {
          this.$set(this.bureauList, i, bureau)
        }
      }
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地区的话，把地区解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getBureauList(obj)
    },

    //新增一个教育局
    addBureau(bureau) {
      this.bureauList.unshift(bureau)
    },

    //删除教育局
    deleteBureau(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          bureau.deleteBureau(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteBureauData(self.bureauList, value.id)
          })
        },
      })
    },

    //删除数据
    deleteBureauData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //查询教育局
    searchBureau() {
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = 1
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      this.getBureauList(obj)
    },

    //教育局列表
    getBureauList(params) {
      this.loading = true
      bureau.getBureauList(params).then((res) => {
        console.log('当前的教育局列表是', res.data.list)
        this.bureauList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
      let arr = []
      if (this.queryParam.provinceId) {
        arr[0] = this.queryParam.provinceId
      }
      if (this.queryParam.cityId) {
        arr[1] = this.queryParam.cityId
      }
      if (this.queryParam.districtId) {
        arr[2] = this.queryParam.districtId
      }
      this.queryParam.addressSelect = arr
    } else {
      this.queryParam = {}
    }
    this.getBureauList(this.queryParam)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
</style>
